export type CampaignType = 'ugc' | 'contest' | 'audition';

export interface CampaignTypeConfig {
    enabled: boolean;
}

/**
 * Toggle campaign types on / off here.
 * Disabled types show a padlock and cannot be selected.
 */
export const CAMPAIGN_TYPE_FLAGS: Record<CampaignType, CampaignTypeConfig> = {
    ugc: { enabled: true },
    contest: { enabled: true },
    audition: { enabled: true },
};

/** @deprecated Prefer CAMPAIGN_TYPE_FLAGS.contest.enabled */
export function isContestCampaignEnabled(): boolean {
    return CAMPAIGN_TYPE_FLAGS.contest.enabled;
}
